// The terms attendee-written and organizer-written markup renders under.
//
// bash.hackclub.com shares an origin with the signed-in platform, so this
// markup never touches the document. It goes into a frame whose sandbox grants
// nothing but popups: no scripts, no same-origin, no forms, no navigating the
// page that hosts it. The frame is an opaque origin, so even CSS tricks have
// nothing of ours to read.
//
// One definition, used by the organizer's custom section and by a hosted
// attendee site, so neither can drift into being the lax one.
const CSP = [
  "default-src 'none'",
  // Scripts can't run in the sandbox regardless; saying so twice costs nothing.
  "script-src 'none'",
  "style-src 'unsafe-inline'",
  // Any https image, which is what makes the escape hatch usable before photo
  // uploads land. The cost is that an author can see the IPs of people who
  // open their page - the same thing any link on it already gives them.
  "img-src https: data:",
  "font-src https:",
  "frame-src 'none'",
  "form-action 'none'",
  "base-uri 'none'",
].join("; ");

// Without allow-popups a link inside the frame silently does nothing, which
// reads as "the platform broke my code". The base target sends them to a new
// tab instead of trying to navigate a frame the CSP won't let load anything.
export const SANDBOX = "allow-popups allow-popups-to-escape-sandbox";

export function sandboxedDocument(html: string, css?: string | null) {
  const head =
    `<meta http-equiv="Content-Security-Policy" content="${CSP}">` +
    `<meta name="viewport" content="width=device-width, initial-scale=1">` +
    `<base target="_blank">` +
    (css ? `<style>${css}</style>` : "");

  return head + html;
}

// The organizer's custom section sits inside a Panel on our own page, so it
// gets our type and a transparent ground rather than a bare white document.
export function sandboxedSection(html: string) {
  return (
    `<meta http-equiv="Content-Security-Policy" content="${CSP}">` +
    `<meta name="viewport" content="width=device-width, initial-scale=1">` +
    `<base target="_blank">` +
    `<style>html,body{margin:0;padding:0;font-family:'Host Grotesk',system-ui,sans-serif;color:#613301;background:transparent}</style>` +
    html
  );
}
